import script from "./CounsellingVideoSession.vue?vue&type=script&setup=true&lang=js"
export * from "./CounsellingVideoSession.vue?vue&type=script&setup=true&lang=js"

import "./CounsellingVideoSession.vue?vue&type=style&index=0&id=2d566230&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d566230"]])

export default __exports__